import React, { Component } from "react"
import Footer from "./organisms/footer/Footer"
import Header from "./organisms/header/index"
import withRoot from "../withRoot"

const Layout = ({ children }) => (
  <div>
    <Header />
    {children}
    <Footer />
  </div>
)

export default withRoot(Layout)
